export const SET_DEFAULT_COUNTERS = 'CONTAINERS/SET_DEFAULT_COUNTERS';
export const SET_SELECTED_CONTAINER = 'CONTAINERS/SET_SELECTED_CONTAINER';
export const UNSET_SELECTED_CONTAINER = 'CONTAINERS/UNSET_SELECTED_CONTAINER';
export const SET_CONTAINERS_LIST = 'CONTAINERS/SET_CONTAINERS_LIST';
export const SET_CONTAINERS_FETCHING_STATUS = 'CONTAINERS/SET_CONTAINERS_FETCHING_STATUS';
export const UNSET_CONTAINERS_FETCHING_STATUS = 'CONTAINERS/UNSET_CONTAINERS_FETCHING_STATUS';
export const SET_CONTAINER_TYPES_LIST = 'CONTAINERS/SET_CONTAINER_TYPES_LIST';
export const SET_CONTAINERS_LIST_FORM = 'CONTAINERS/SET_CONTAINERS_LIST_FORM';
export const UNSET_CONTAINERS_AUTOCOMPLETE_LIST = 'CONTAINERS/UNSET_CONTAINERS_AUTOCOMPLETE_LIST';
export const UNSET_DEFAULT_COUNTERS = 'UNSET_DEFAULT_COUNTERS';